var _path, _path2, _rect;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyKegDetails(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 147,
    viewBox: "0 0 102 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.30121 1.95433C3.55819 2.07177 2.21777 3.57095 2.21777 5.38027V17.8008C2.21777 19.7036 3.70692 21.2461 5.54386 21.2461H96.9686C98.8055 21.2461 100.295 19.7036 100.295 17.8008V5.38027C100.295 3.57095 98.9543 2.07177 97.2112 1.95433C89.0957 1.4075 66.7061 0 51.2562 0C35.8063 0 13.4168 1.4075 5.30121 1.95433ZM42.1613 3.03516C40.543 3.03516 39.2311 4.39404 39.2311 6.07031C39.2311 7.74658 40.543 9.10547 42.1613 9.10547H59.8395C61.4577 9.10547 62.7696 7.74658 62.7696 6.07031C62.7696 4.39404 61.4577 3.03516 59.8395 3.03516H42.1613Z",
    fill: "#B2B2B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.96154 29.2854C1.96154 27.3826 3.45068 25.8401 5.28762 25.8401H96.7124C98.5493 25.8401 100.038 27.3826 100.038 29.2854V60.4991C101.222 61.3241 102 62.7242 102 64.3127C102 65.9012 101.222 67.3014 100.038 68.1263V111.03C101.222 111.855 102 113.255 102 114.844C102 116.432 101.222 117.833 100.038 118.658V141.832C100.038 143.735 98.5493 145.278 96.7124 145.278H5.28763C3.45068 145.278 1.96154 143.735 1.96154 141.832V118.658C0.778349 117.833 0 116.432 0 114.844C0 113.255 0.778349 111.855 1.96154 111.03V68.1263C0.778349 67.3014 0 65.9012 0 64.3127C0 62.7242 0.778349 61.3241 1.96154 60.4991V29.2854ZM10.3061 32.1562C8.94743 32.1562 7.84605 33.2576 7.84605 34.6162V135.352C7.84605 136.711 8.94744 137.812 10.3061 137.812H91.6937C93.0524 137.812 94.1537 136.711 94.1537 135.352V34.6162C94.1537 33.2576 93.0524 32.1562 91.6937 32.1562H10.3061Z",
    fill: "#B2B2B2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.8457,
    y: 32.1562,
    width: 86.3077,
    height: 105.656,
    rx: 2.46,
    fill: "transparent"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyKegDetails);
export default __webpack_public_path__ + "static/media/emptyKegDetails.8288d1ce.svg";
export { ForwardRef as ReactComponent };